<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >

      

        <v-dialog
          v-model="dialog"
          width="1000"
          hegiht="auto"
        >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Register a new student
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
            <!-- <v-card-title
          class="headline success lighten-2"
          primary-title
        >
          Privacy Policy
        </v-card-title> -->
            <Form
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="getBackData"
              />

            <v-divider/>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="primary"
                flat
                @click="dialog = false"
              >
                I accept
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <material-card
          color="green"
          title="Course List"
          text="The courses those are being provided by BacBon"
        >
        </material-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Form from '@/views/Form'
export default {
  components: {
    Form
  },
  data () {
    return {
      dialog: false,
      item: {
        'title': 'Register new Student',
        'subTitle': 'This is the subtitle',
        'width': 'md4 sm6 xs12',
        'submitText' : 'Register'
      },
      valueObj: { 
        'firstName': 'Mehedi',
        'lastName': 'Rueen',
        'password': '123456',
        'email': 'rueen@gmail.com',
        'phone': '01740131090',
      },
      inputFields: [
        {
          label: 'First Name',
          type: 'text',
          isEnable: true,
          name: 'firstName',
          formName: 'First name',
          validationRules: 'required',
          nameRules: [
            v => !!v || 'First name is required',
            v => (v && v.length <= 10) || 'First name must be less than 10 characters',
            v => /^[\w. ]+$/.test(v) || 'Special character not allowed'
          ]
        },
        {
          label: 'Last Name',
          type: 'text',
          isEnable: true,
          name: 'lastName',
          formName: 'Last name',
          nameRules: [
            v => !!v || 'Last name is required',
          ]
        },
        {
          label: 'Password',
          type: 'password',
          isEnable: true,
          name: 'password',
          formName: 'Password',
          nameRules: [
            v => !!v || 'Password is required',
          ]
        },
        {
          label: 'Email',
          type: 'email',
          isEnable: true,
          name: 'email',
          formName: 'Email',
          nameRules: [
            v => !!v || 'Email is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid'
          ]
        },
        {
          label: 'Phone',
          type: 'text',
          isEnable: true,
          name: 'phone',
          formName: 'Phone',
          validationRules: 'required',
          nameRules: [
            v => !!v || 'Phone is required',
          ]
        },
        {
          label: 'Address',
          type: 'text',
          isEnable: false,
          name: 'address',
          formName: 'Address',
          validationRules: ''
        }
      ]
    }
  },
  
  methods: {
    getBackData (value) {
      console.log(value)
    }
  }
}
</script>
